import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { ERROR_TYPE } from '@/constants/form';
import styles from './FormErrorV2.module.scss';

type Error = {
	type?: string;
	message?: string;
};

type FormErrorV2Props = {
	error?: Error;
};

export const FormErrorV2 = (props: FormErrorV2Props): React.JSX.Element => {
	const { error = {} } = props;

	const { t } = useTranslation();
	const { type, message } = error;

	const errorMessage = useMemo(() => {
		switch (type) {
			case ERROR_TYPE.REQUIRED:
				return t('forms.requiredField');
			case ERROR_TYPE.PHONE:
				return t('forms.validPhone');
			case ERROR_TYPE.DATE_OVER_LIMIT:
			case ERROR_TYPE.DATE_UNDER_LIMIT:
				return message;
			case ERROR_TYPE.POSTAL_CODE:
				return t('forms.validPostalCode');
			case ERROR_TYPE.INTRACOM_NUMBER:
				return t('forms.errors.invalidSiret');
			default:
				if (message) {
					return t(message);
				}
				return 'Error'; // TODO_FORM définir un message par défault
		}
	}, [type, message]);

	return error ? (
		<div className={styles.error} data-test-id="error-message">
			{errorMessage}
		</div>
	) : null;
};

FormErrorV2.propTypes = {
	error: PropTypes.shape({
		type: PropTypes.string,
		message: PropTypes.string,
	}),
};

export default FormErrorV2;
